/* tslint:disable */
/* eslint-disable */
/**
 * Coproperty API
 * MRI coproperties (the risk entity of the MRI branch) — creation, structural attributes, buildings, and attachment to the risk.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { QuestionnaireAnswer } from './QuestionnaireAnswer';
import {
    QuestionnaireAnswerFromJSON,
    QuestionnaireAnswerFromJSONTyped,
    QuestionnaireAnswerToJSON,
    QuestionnaireAnswerToJSONTyped,
} from './QuestionnaireAnswer';

/**
 * 
 * @export
 * @interface SaveCopropertyQuestionnaireRequest
 */
export interface SaveCopropertyQuestionnaireRequest {
    /**
     * 
     * @type {Array<QuestionnaireAnswer>}
     * @memberof SaveCopropertyQuestionnaireRequest
     */
    answers: Array<QuestionnaireAnswer>;
}

/**
 * Check if a given object implements the SaveCopropertyQuestionnaireRequest interface.
 */
export function instanceOfSaveCopropertyQuestionnaireRequest(value: object): value is SaveCopropertyQuestionnaireRequest {
    if (!('answers' in value) || value['answers'] === undefined) return false;
    return true;
}

export function SaveCopropertyQuestionnaireRequestFromJSON(json: any): SaveCopropertyQuestionnaireRequest {
    return SaveCopropertyQuestionnaireRequestFromJSONTyped(json, false);
}

export function SaveCopropertyQuestionnaireRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveCopropertyQuestionnaireRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'answers': ((json['answers'] as Array<any>).map(QuestionnaireAnswerFromJSON)),
    };
}

export function SaveCopropertyQuestionnaireRequestToJSON(json: any): SaveCopropertyQuestionnaireRequest {
    return SaveCopropertyQuestionnaireRequestToJSONTyped(json, false);
}

export function SaveCopropertyQuestionnaireRequestToJSONTyped(value?: SaveCopropertyQuestionnaireRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'answers': ((value['answers'] as Array<any>).map(QuestionnaireAnswerToJSON)),
    };
}

